import { useNavigate } from "react-router-dom";
import useGoBack from "./useGoBack";
import useIsInappWebview from "./useIsInappWebview";

export default function useGoHomeWeb() {
  const navigate = useNavigate();
  const goBack = useGoBack();
  const isInappWebview = useIsInappWebview();

  const goHome = () => {
    if (isInappWebview) {
      // In in-app webview, use the existing back navigation behavior
      // so the app can decide how to handle history.
      goBack();
      return;
    }
    // On web (not in-app), navigate to home and replace history
    navigate("/", { replace: true });
  };

  return { goHome };
}
